import React from 'react';
import {useEffect} from 'react';
import '../css/page.css'

const SubPage = ({page}) => {
    // console.log(page)
    var desc = document.getElementsByClassName('description')

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search); 
        let langCode = urlParams.get('langcode')?.toLowerCase();
        console.log(langCode)
        if(langCode === undefined)
            langCode = "tr"
        fetch(`${process.env.REACT_APP_CONTENTLIST_API_URL}/${page}?langCode=`+langCode)
        .then((r) => r.json())
        .then((data) =>{
            desc[0].innerHTML = data.description
        })
        .catch(
            (error) => { return "error" }
        );
    }, []);

    
    return (
        <>
            <div className='description'></div>
        </>
    );
};

export default SubPage;